import AppContext from "@/contexts/appctx/app-context";
import ChevDown from "@/seed/components/elements/chev-down";
import RoundInfo from "@/seed/components/elements/round-info";
import TokenSaleHero from "@/seed/components/modules/token-sale/token-sale-hero";
import PoolContext from "@/seed/contexts/pool/pool-context";
// import { data as userWalletData } from "@/seed/shared/user-wallet";
import { useContext } from "react";

const TokenPurchase = () => {
    const { layoutContentDef, saleEvent } = useContext(PoolContext);
    const { user } = useContext(AppContext);
    console.log("TokenPurchase", { layoutContentDef, saleEvent, user });
    if (!layoutContentDef || !saleEvent) return <div>Loading</div>;

    let userWalletData;
    let purchaseForm;
    if (user?.ether) {
        userWalletData = user?.ether;
        if (user?.isWinner) {
            purchaseForm = layoutContentDef.tokenSaleHero.purchaseForm;
        }
    }

    console.log("TokenPurchase", {user, purchaseForm, layoutContentDef, saleEvent, userWalletData });

    return (
        <>
            <div className="absolute">
                <section id="hero" className="bg-[url('/img/hero.png')] bg-center bg-cover">
                    <div className="bg-gradient-to-b from-black/[70%] to-black/[100%] inset-0 w-screen h-screen"></div>
                </section>
                <section id="user-guide" className="">
                    <div className="bg-gradient-to-b from-black/[70%] to-black/[100%] inset-0 w-screen h-screen"></div>
                </section>
            </div>
            <div className="absolute w-screen top-[20%] landscape:top-[30%]">
                <div className="container mx-auto flex flex-col items-center justify-center w-full">
                    <TokenSaleHero
                        data={{
                            ...layoutContentDef.tokenSaleHero,
                            countdown: {
                                ...layoutContentDef.tokenSaleHero.countdown,
                                ...saleEvent.countdown,
                            },
                            saleInfo: saleEvent,
                        }}
                        purchaseForm={purchaseForm}
                        userWallet={userWalletData}
                    />
                    <ChevDown />
                    <RoundInfo data={saleEvent.roundOverview} />
                </div>
            </div>
        </>
    );
};

export default TokenPurchase;
